import React from "react";
import Button from "sulu-admin-bundle/components/Button";
import shirt from "../../../svgs/Shirt";
import SwapIcon from "../../../svgs/Swap";
import "./header.scss";
import Loader from "sulu-admin-bundle/components/Loader";
import { translate as suluTranslate } from "sulu-admin-bundle/utils";
import multiSelectionStyles from "../CustomStyle.scss";
import SingleSelect from "sulu-admin-bundle/components/SingleSelect";
import { toJS } from "mobx";

const Option = SingleSelect.Option;

const headerColums = (props) => {
    const jersey = props?.t("sulu_admin.match.jersey");
    const name = props?.t("sulu_admin.match.first.lastname");
    const captain = props?.t("sulu_admin.match.captain");
    const swap = props?.t("sulu_admin.match.swap");

    const hC = (
        <div
            style={{
                display: "grid",
                gridTemplateColumns: "1fr 2fr repeat(6, 1fr)",
                width: "80%",
            }}
        >
            <div> {jersey}*</div>
            <div> {name}</div>
            <div> Pass-Nr.</div>
            <div> Status</div>
            <div> {captain}*</div>
            <div> GK*</div>
            <div> {swap}</div>
            <div> Position</div>
        </div>
    );

    return hC;
};

const footer = (
    noOfSelectedPlayer,
    minPlayers,
    maxPlayers,
    dataPath,
    hideLegend,
    translate
) => {
    const captain = translate("sulu_admin.match.captain");
    const captainLegend = translate("sulu_admin.match.legend.captain");
    const blackShirtLabel = translate("sulu_admin.match.legend.black_shirt");
    const whiteShirtLabel = translate("sulu_admin.match.legend.white_shirt");

    if (hideLegend) {
        return;
    }

    const isMatchPlayers = dataPath !== "/coreSquad";

    const warningMessage =
        noOfSelectedPlayer < minPlayers
            ? suluTranslate("sulu_admin.match.player_min", {
                  number: minPlayers - noOfSelectedPlayer,
              })
            : isMatchPlayers && noOfSelectedPlayer > maxPlayers
            ? suluTranslate("sulu_admin.match.player_max", {
                  number: noOfSelectedPlayer - maxPlayers,
              })
            : "";

    const numberColor = {
        color:
            noOfSelectedPlayer < minPlayers
                ? "red"
                : isMatchPlayers && noOfSelectedPlayer > maxPlayers
                ? "red"
                : "green",
    };

    return (
        <>
            <div
                style={{
                    backgroundColor: "#E5E5E5",
                    fontSize: "16px",
                    padding: "10px 20px",
                    border: "1px solid #DDDDDD",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                }}
            >
                Spieler gesamt {noOfSelectedPlayer}
                <strong style={numberColor}>
                    ({minPlayers}
                    {isMatchPlayers && ` - ${maxPlayers}`})
                </strong>
                {warningMessage && (
                    <div
                        style={{
                            color: "red",
                            fontSize: "12px",
                        }}
                    >
                        {warningMessage}
                    </div>
                )}
            </div>

            <div>
                <div style={{ margin: "10px", marginLeft: "100px" }}>
                    <p>
                        {shirt({ fill: "black" })} {blackShirtLabel}
                    </p>
                    <p>
                        {shirt({ fill: "white", stroke: "black" })}{" "}
                        {whiteShirtLabel}
                    </p>
                    {/* <p> { shirt({fill: 'lightgrey', stroke: 'black'}) } Spieler*in ist festgespielt. Spieler*in kann nicht mehr in unteren Teams eingesetzt werden.</p> */}

                    <p>
                        <span>{captain}</span> - {captainLegend}
                    </p>
                </div>
            </div>
        </>
    );
};

const inputNumb = (
    item,
    displayProperty,
    itemClickHandler,
    additionalParams = ""
) => {
    const number = item[displayProperty];

    return (
        <input
            style={{
                boxSizing: "border-box",
                width: "27px",
                textAlign: "center",
                height: "27px",
                left: "0px",
                right: "0px",
                top: "0px",
                background: "#FFFFFF",
                border:
                    !number || number == "/"
                        ? "1px solid red"
                        : "1px solid #ccc",
                borderRadius: "3px",
            }}
            type="number"
            inputMode="numeric"
            onChange={(ev) => {
                itemClickHandler(
                    ev.currentTarget.value,
                    item.id,
                    displayProperty
                );
            }}
            value={number && number !== "/" ? number : ""}
        ></input>
    );
};

const positionDropdown = (
    item,
    displayProperty,
    itemClickHandler,
    positions,
    selectedPositions
) => {
    let playerPositions = toJS(positions);

    const selectedValues = item[displayProperty];

    return (
        <div
            style={{
                width: "7.6rem",
            }}
        >
            <SingleSelect
                displayValue={"Choose position"}
                name={displayProperty}
                value={selectedValues}
                onChange={(value) => {
                    itemClickHandler(value, item.id, displayProperty);
                }}
            >
                <Option key="no-position" value={0}>
                    No position
                </Option>
                {playerPositions.map((position) => {
                    let isPositionDisabled = false;

                    if (selectedPositions.indexOf(position.id) !== -1) {
                        isPositionDisabled = true;
                    }

                    return (
                        <Option
                            disabled={isPositionDisabled}
                            key={position.id}
                            value={position.id}
                        >
                            {position.name}
                            {position.positionType === "isGoalkeeper" && "*"}
                        </Option>
                    );
                })}
            </SingleSelect>
        </div>
    );
};

const columnCustom = (
    item,
    itemColumnClass,
    itemClickHandler,
    displayProperty,
    columns,
    inputNumb,
    additionalParams = {},
    data,
    handlerClick,
    index,
    positions,
    isDisabled,
    swapClick,
    selectedPositions
) => {
    // item.id is really a row id
    const loadingColumns = additionalParams.loadingMatchesTeams.filter(
        (cur) => cur.id === item.id
    );

    const isLoading = Boolean(
        loadingColumns.some((column) => column?.prop === displayProperty) &&
            additionalParams.isLoading
    );
    const allowedProperties = [
        "shirtNumber",
        "isInCoreSquad",
        "isCaptain",
        "lastName",
        "passportNumber",
        "position",
        "swap",
        "isCheckbox",
    ];

    const checkboxablePosition = positions.find(
        (position) => position.isCheckbox
    );

    const renderLoader = (
        <div
            style={{
                width: 15,
                display: "inline-block",
                verticalAlign: "middle",
            }}
        >
            <Loader size={15} />
        </div>
    );

    const fill = null;
    const renderContent = () => {
        switch (displayProperty) {
            case "shirtNumber":
                return isLoading
                    ? renderLoader
                    : inputNumb(item, displayProperty, itemClickHandler, {
                          disabled: additionalParams.isLoading,
                      });
            case "isInCoreSquad":
                return shirt({ isCore: item[displayProperty], fill });
            case "lastName":
                return `${item.lastName} , ${item.firstName}`;
            case "isCaptain":
                return isLoading ? (
                    renderLoader
                ) : (
                    <input
                        type="checkbox"
                        disabled={additionalParams.isLoading}
                        onChange={(ev) =>
                            itemClickHandler(
                                ev.currentTarget.checked,
                                item.id,
                                displayProperty
                            )
                        }
                        checked={!!item[displayProperty]}
                    />
                );
            case "isCheckbox":
                const isCheckboxChecked =
                    item.position === checkboxablePosition?.id;

                const isGoalkeeperPossible = item.teamPositions?.some(
                    (position) => {
                        return position.positionType === "isGoalkeeper";
                    }
                );

                return (
                    <input
                        checked={isCheckboxChecked}
                        type="checkbox"
                        disabled={
                            additionalParams.isLoading ||
                            (item.teamPositions?.length &&
                                !isGoalkeeperPossible)
                        }
                        onChange={(e) => {
                            const checked = e.target.checked;

                            if (checked) {
                                itemClickHandler(
                                    checkboxablePosition.id,
                                    item.id,
                                    displayProperty
                                );
                            } else {
                                itemClickHandler(0, item.id, displayProperty);
                            }
                        }}
                    />
                );
            case "swap":
                return (
                    <div
                        className={multiSelectionStyles.swap}
                        onClick={() => swapClick(item)}
                        style={{
                            width: "24px",
                            height: "24px",
                            borderRadius: "3px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                        }}
                    >
                        <SwapIcon />
                    </div>
                );
            case "position":
                return positionDropdown(
                    item,
                    displayProperty,
                    itemClickHandler,
                    positions,
                    selectedPositions
                );

            default:
                if (item[displayProperty]) {
                    return item.passportId ? (
                        <div onClick={() => handlerClick(item)}>
                            <Button skin="link">{item[displayProperty]}</Button>
                        </div>
                    ) : (
                        <div style={{ color: "red" }}>Invalid Pass.</div>
                    );
                }
                return null;
        }
    };

    return allowedProperties.includes(displayProperty) ? (
        <div
            className={`${itemColumnClass}`}
            key={`${displayProperty}-${item.id}`}
            style={{
                paddingLeft: "0",
                display: "flex",
                alignItems: "center",
                width: "fit-content",
            }}
        >
            {renderContent()}
        </div>
    ) : null;
};

export { headerColums as hackHeader, inputNumb, columnCustom, footer };
